import React from 'react';
import styled from 'styled-components';
import { AlertTriangle, AlertCircle, CheckCircle, Info } from 'lucide-react';
import { Modal } from './Modal';
import { theme } from '../../tokens';
import { Button } from '../Button/Button';

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacing[4]};

  svg {
    width: 48px;
    height: 48px;
  }

  ${({ $variant }) => {
    switch ($variant) {
      case 'danger':
        return `color: ${theme.colors.error[500]};`;
      case 'warning':
        return `color: ${theme.colors.warning[500]};`;
      case 'success':
        return `color: ${theme.colors.success[500]};`;
      default:
        return `color: ${theme.colors.primary[500]};`;
    }
  }}
`;

const Message = styled.p`
  text-align: center;
  color: ${theme.colors.text.secondary};
  font-size: ${theme.fontSizes.base};
  margin: 0;
  line-height: 1.6;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${theme.spacing[3]};
  justify-content: center;
  width: 100%;
`;

const iconMap = {
  danger: AlertTriangle,
  warning: AlertCircle,
  success: CheckCircle,
  info: Info,
};

export const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'info', // 'danger', 'warning', 'success', 'info'
  loading = false,
}) => {
  const Icon = iconMap[variant] || iconMap.info;

  const getConfirmVariant = () => {
    if (variant === 'danger') return 'danger';
    if (variant === 'warning') return 'warning';
    return 'primary';
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <ButtonGroup>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelText}
          </Button>
          <Button
            variant={getConfirmVariant()}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmText}
          </Button>
        </ButtonGroup>
      }
    >
      <IconWrapper $variant={variant}>
        <Icon />
      </IconWrapper>
      <Message>{message}</Message>
    </Modal>
  );
};

ConfirmModal.displayName = 'ConfirmModal';

export default ConfirmModal;
